import classNames from "classnames";
/**
 * Internal dependencies.
 */
import Link from "components/link/link";
/**
 * External dependencies.
 */
import { useRouter } from "next/router";
import { useMemo, useState } from "react";
import { getSlug } from "utils";

import { Trans } from "@lingui/macro";

import { SidebarList } from "./sidebar-list";

interface SidebarProp {
  app?: boolean;
  categories: any;
  current?: any;
  sublinks?: boolean;
  global: {
    attributes: {
      ContactLink: string,
      RelNoFollow?: boolean,
      OpenInNewTab?: boolean,
    },
  };
}

const Sidebar: React.FC<SidebarProp> = ({
  categories,
  current,
  sublinks,
  global,
  app,
}) => {
  const router = useRouter();
  const [active, setActive] = useState(false);

  const currentText = () => {
    if (active) {
      return "";
    }

    if (current) {
      return current.attributes.Title;
    } else if (categories && categories[0]) {
      return categories[0]?.attributes.Title;
    }
  };

  const filterCategories = useMemo(
    () =>
      categories?.filter((item: any) => {
        const key = app ? "apps" : "themes";
        const theme = item.attributes.documentations.data.some(
          ({ attributes }: any) => {
            return attributes[key].data.some(({ attributes: theme }: any) => {
              return getSlug(theme) === router.query.theme;
            });
          },
        );

        item.attributes.documentations.data =
          item.attributes.documentations.data.filter((doc: any) => {
            return doc.attributes[key].data.find(
              (theme: any) => getSlug(theme.attributes) === router.query.theme,
            );
          });

        item.attributes.documentations.data.map((doc: any) => {
          if (doc.attributes.order === null)
            return (doc.attributes.order =
              item.attributes.documentations.data.length + 1);

          return doc.attributes.order;
        });

        item.attributes.documentations.data.sort(
          (a: any, b: any) => a.attributes.order - b.attributes.order,
        );

        return item.attributes.documentations.data.length > 0 && theme;
      }),
    [categories],
  );

  return (
    <div className="sidebar">
      <div className="sidebar__mobile">
        <button
          className={classNames({ active })}
          type="button"
          onClick={() => setActive(!active)}
        >
          {currentText()}
          <span></span>
        </button>
      </div>

      {filterCategories?.map((item: any) => (
        <SidebarList
          key={item.id}
          item={item}
          current={current}
          sublinks={sublinks}
          active={active}
          app={app}
        />
      ))}
      <Link
        href={global.attributes.ContactLink}
        className="btn btn--grey"
        OpenInNewTab={global.attributes.OpenInNewTab}
        RelNoFollow={global.attributes.RelNoFollow}
      >
        <Trans>Contact Us</Trans>
      </Link>
    </div>
  );
};

export default Sidebar;
